import { isTypeHeroCardSection } from '@platform/contentful';
import { Entry } from 'contentful';
import Divider from './util/Divider';
import MarkdownText from './util/MarkdownText';
import ContentfulSmallCta from './ContentfulSmallCta';

const ContentfulHeroCardSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeHeroCardSection(entry)) {
    return null;
  }

  return (
    <div
      className='-mx-2 sm:-mx-5 px-4 py-24 bg-no-repeat bg-left bg-cover md:min-h-[85vh] flex items-center'
      style={{
        backgroundImage: `url('${entry.fields.image?.fields.file?.url}')`,
      }}
    >
      <div className='max-w-[1440px] mx-auto sm:my-11 '>
        <div className='sm:ml-[33%] flex flex-col text-left p-8 bg-white'>
          <div className='font-header text-4xl sm:text-5xl leading-11 sm:leading-14 font-bold text-gray-500'>
            {entry.fields.header}
          </div>
          <Divider />
          <MarkdownText text={entry.fields.description} />
          <ContentfulSmallCta entry={entry.fields.cta} />
        </div>
      </div>
    </div>
  );
};

export default ContentfulHeroCardSection;
